module.exports = __webpack_public_path__ + "public/1.0.1_633693/img/default-chat.230d47f6.png";